type BadgeVariant = 'new' | 'in_progress' | 'resolved' | 'brand' | 'gray';

interface StatusBadgeProps {
  label: string;
  variant?: BadgeVariant;
  className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  new: 'bg-badge-danger-bg border-badge-danger-border text-text-danger',
  in_progress: 'bg-badge-warn-bg border-badge-warn-border text-text-warning',
  resolved: 'bg-badge-success-bg border-badge-success-border text-text-success',
  brand: 'bg-badge-brand-bg border-badge-brand-border text-text-brand',
  gray: 'bg-badge-gray-bg border-badge-gray-border text-text-secondary',
};

export function StatusBadge({ label, variant = 'gray', className = '' }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded-md border text-xs font-medium leading-4 whitespace-nowrap ${variantStyles[variant]} ${className}`}
    >
      {label}
    </span>
  );
}

export function getStatusVariant(status: string): BadgeVariant {
  switch (status) {
    case 'open': return 'new';
    case 'in_progress': return 'in_progress';
    case 'closed': return 'resolved';
    default: return 'gray';
  }
}

export function getStatusLabel(status: string): string {
  switch (status) {
    case 'open': return 'New';
    case 'in_progress': return 'In Progress';
    case 'closed': return 'Resolved';
    default: return status;
  }
}
